import yup from 'src/libraries/validator.library';
import {
  DistrictSchema,
  IDistrictForm,
  DistrictListPayloadSchema,
} from 'src/models/district.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('/districts', { limit: 0 }, DistrictListPayloadSchema);
  },
  addPOST: async (data: IDistrictForm) => {
    return http.post('districts', data, DistrictSchema);
  },
  updatePUT: async (id: number, data: IDistrictForm) => {
    return http.put(`districts/${id}`, data, DistrictSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`districts/${id}`, yup.mixed());
  },
};

export default services;
